import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { EventTypes, dispatch } from 'modules/core/lib/pubSub'

import { useFetchTimeSettingsBreakConfigurations } from 'modules/attendance/hooks/useFetchTimeSettingsBreakConfigurations'
import type AttendanceSettingForm from 'modules/attendance/lib/forms/AttendanceSettingForm'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

const useUpdateAttendanceSetting = (
  settingForm: AttendanceSettingForm,
  attendanceSetting: AttendanceSetting,
  refreshBreakConfigurations = false,
  onComplementaryHoursEnabled?: () => void
) => {
  const { refetch: refetchTimeSettingsBreakConfigurations } =
    useFetchTimeSettingsBreakConfigurations(attendanceSetting.id)

  const { running: loading, performAction: updateSetting } = useAsyncAction(
    async () => {
      const previousComplementaryHoursValue = attendanceSetting.enableComplementaryHours

      await settingForm.save(attendanceSetting)

      dispatch({
        type: EventTypes.TIMETRACKING_POLICY_UPDATED,
      })

      if (!previousComplementaryHoursValue && attendanceSetting.enableComplementaryHours) {
        onComplementaryHoursEnabled?.()
      }

      if (refreshBreakConfigurations) {
        refetchTimeSettingsBreakConfigurations()
      }
    },
    { successFlash: true }
  )

  return {
    loading,
    updateSetting,
  }
}

export default useUpdateAttendanceSetting
